export const NOON_REPORT_ACTIVITIES = [
  'AT_SEA',
  'COSP',
  'EOSP',
  'FAW',
  'ANCHOR_ARRIVAL',
  'ANCHOR_DEPARTURE',
  'AT_ANCHOR',
  'AT_ANCHOR_COMMENCED_BUNKERING',
  'AT_ANCHOR_COMPLETED_BUNKERING',
  'PORT_ARRIVAL',
  'PORT_DEPARTURE',
  'AT_PORT_LOADING',
  'AT_PORT_DISCHARGING',
  'STS_ARRIVAL',
  'STS_DEPARTURE',
  'AT_STS_LOADING',
  'AT_STS_DISCHARGE',
  'DRIFTING_ARRIVAL',
  'DRIFTING_DEPARTURE',
  'AT_DRIFTING',
  'DRY_DOCKING_ARRIVAL',
  'DRY_DOCKING_DEPARTURE',
  'AT_DRY_DOCKING',
] as const;

export type NoonReportActivity = (typeof NOON_REPORT_ACTIVITIES)[number];

export const NOON_ACTIVITY_LABELS: Record<NoonReportActivity, string> = {
  AT_SEA: 'At sea',
  COSP: 'COSP',
  EOSP: 'EOSP',
  FAW: 'FAW',
  ANCHOR_ARRIVAL: 'Anchor arrival',
  ANCHOR_DEPARTURE: 'Anchor departure',
  AT_ANCHOR: 'At anchor',
  AT_ANCHOR_COMMENCED_BUNKERING: 'At anchor / commenced bunkering',
  AT_ANCHOR_COMPLETED_BUNKERING: 'At anchor / completed bunkering',
  PORT_ARRIVAL: 'Port arrival',
  PORT_DEPARTURE: 'Port departure',
  AT_PORT_LOADING: 'At port / loading',
  AT_PORT_DISCHARGING: 'At port / discharging',
  STS_ARRIVAL: 'STS arrival',
  STS_DEPARTURE: 'STS departure',
  AT_STS_LOADING: 'At STS / loading',
  AT_STS_DISCHARGE: 'At STS / discharge',
  DRIFTING_ARRIVAL: 'Drifting arrival',
  DRIFTING_DEPARTURE: 'Drifting departure',
  AT_DRIFTING: 'At drifting',
  DRY_DOCKING_ARRIVAL: 'Dry-docking arrival',
  DRY_DOCKING_DEPARTURE: 'Dry-docking departure',
  AT_DRY_DOCKING: 'At dry-docking',
};

export const NOON_ACTIVITY_OPTIONS = NOON_REPORT_ACTIVITIES.map((value) => ({
  value,
  label: NOON_ACTIVITY_LABELS[value],
}));

export const NOON_CONDITION_OPTIONS = [
  { value: 'LADEN', label: 'Laden' },
  { value: 'BALLAST', label: 'Ballast' },
];

export const NOON_GMT_OPTIONS = [
  { value: '-12', label: 'GMT -12' },
  { value: '-11', label: 'GMT -11' },
  { value: '-10', label: 'GMT -10' },
  { value: '-9', label: 'GMT -9' },
  { value: '-8', label: 'GMT -8' },
  { value: '-7', label: 'GMT -7' },
  { value: '-6', label: 'GMT -6' },
  { value: '-5', label: 'GMT -5' },
  { value: '-4', label: 'GMT -4' },
  { value: '-3', label: 'GMT -3' },
  { value: '-2', label: 'GMT -2' },
  { value: '-1', label: 'GMT -1' },
  { value: '+0', label: 'GMT +0' },
  { value: '+1', label: 'GMT +1' },
  { value: '+2', label: 'GMT +2' },
  { value: '+3', label: 'GMT +3' },
  { value: '+4', label: 'GMT +4' },
  { value: '+5', label: 'GMT +5' },
  { value: '+6', label: 'GMT +6' },
  { value: '+7', label: 'GMT +7' },
  { value: '+8', label: 'GMT +8' },
  { value: '+9', label: 'GMT +9' },
  { value: '+10', label: 'GMT +10' },
  { value: '+11', label: 'GMT +11' },
  { value: '+12', label: 'GMT +12' },
];
